"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeLayoutReferenceLabel = sanitizeLayoutReferenceLabel;
exports.groupLayoutReferencesByCategory = groupLayoutReferencesByCategory;
function sanitizeLayoutReferenceLabel(value) {
    return value.trim().replace(/\s+/g, ' ').toUpperCase();
}
function groupLayoutReferencesByCategory(rows) {
    var _a;
    const byCategory = new Map();
    for (const row of rows) {
        const items = (_a = byCategory.get(row.category)) !== null && _a !== void 0 ? _a : [];
        items.push(row);
        byCategory.set(row.category, items);
    }
    return Array.from(byCategory.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([category, items]) => ({ category, items }));
}
